export const ERROR_MESSAGES = {
  genericError: 'addressInput.error',
  1001: 'addressInput.noResponse',
  1002: 'addressInput.noResponse',
  1003: 'addressInput.error',
  1004: 'addressInput.error',
  1005: 'addressInput.noResponse',
  1006: 'addressInput.error',
  1007: 'addressInput.error',
  1008: 'addressInput.error'
};

export const ADDRESS_TYPE = 'Address';
